import { useQuery } from '@tanstack/react-query';

import {
  getV1IdentityProviderByIdOptions,
  getV1IdentityProvidersOptions,
} from '../../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Identity Providers feature.
 *
 * Thin wrappers over the generated `@hey-api` react-query options. This is the
 * reference for the colocated data-fetching pattern: feature-prefixed
 * `*.queries.ts` / `*.mutations.ts` living next to the feature that uses them.
 */

export const useIdentityProviders = () => useQuery(getV1IdentityProvidersOptions());

export const useIdentityProvider = (id: string) =>
  useQuery({
    ...getV1IdentityProviderByIdOptions({ path: { id } }),
    enabled: !!id,
  });
